<span (click)="publish()" *ngIf="published" class="list-item__action list-item__action--secondary">Despublicar</span>
<span (click)="publish()" *ngIf="!published" class="list-item__action list-item__action--secondary">Publicar</span>
